export type ActionConstant = 'quote/fetchAsync';

export class ActionConstants {
    public static readonly fetch: string = 'quote/fetchAsync';
    public static readonly updateAllQuotesFilterStatus: string = 'quote/updateAllQuotesFilterStatus';
    public static readonly updateAllQuotesPage: string = 'quote/updateAllQuotesPage';
    public static readonly updateAllQuotesFrom: string = 'quote/updateAllQuotesFrom';
    public static readonly updateAllQuotesTo: string = 'quote/updateAllQuotesTo';
}
